import { GET_DEEP_LINK } from 'store/deepLink/actionTypes';
import { selectDeepLink } from 'store/deepLink/selectors';
import { createProcessingSelector } from 'store/loading/selectors';

import { useSelector } from 'hooks';

import Skeleton from 'components/Skeleton';

import { StoreButtonProps } from './types';

import * as S from './styled';

const StoreButton = ({ type, isMobile = false, customLink }: StoreButtonProps) => {
    const isLoading: boolean = useSelector(createProcessingSelector([GET_DEEP_LINK]));
    const deepLinkUrl = useSelector(selectDeepLink);

    return (
        <>
            {isLoading ? (
                <Skeleton width={150} height={45} borderRadius={8} marginLeft={8} />
            ) : (
                <S.StoreBtn isMobile={isMobile} link={customLink || deepLinkUrl} type={type} />
            )}
        </>
    );
};

export default StoreButton;
